export default __webpack_public_path__ + "static/6-4be9cb9f6cacd40ce4da0cae6d05c425.jpeg";